var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.coupon ? [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("redeem_confirm_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_confirm_page.form_desc'))
    }
  }), _vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : _c('div', [_vm.couponType == '1' ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('div', {
    staticClass: "scan-filter"
  }, [_c('coupon-filters', {
    staticClass: "s-mb-3 s-mt-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.scanFilter,
      callback: function callback($$v) {
        _vm.scanFilter = $$v;
      },
      expression: "scanFilter"
    }
  })], 1), _c('div', [_vm.scanFilter == 'qrcode' ? _c('div', {
    staticClass: "qrcode-panel"
  }, [_vm.showQrCodeScanner ? _c('QRCodeScanner', {
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.onScan
    }
  }) : _vm._e()], 1) : _vm.scanFilter == 'manual' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.barcode,
      expression: "barcode"
    }],
    staticClass: "search__input m-auto w-100",
    domProps: {
      "value": _vm.barcode
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value;
      }, _vm.redeemCodeFormatter]
    }
  })]) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 rounded redeem--content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_confirm_page.content'))
    }
  })]) : _vm._e()], 1)])])])]) : _vm._e(), _vm.couponType == '2' ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm.step == '1' ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card__title ml-2 mt-2 mb-2"
  }, [_vm._v("選擇商家")]), _vm._l(_vm.options, function (option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-12 px-2"
    }, [_c('SharedRadio', {
      attrs: {
        "id": "proxy-".concat(idx),
        "value": option.value,
        "name": "proxy"
      },
      model: {
        value: _vm.proxy,
        callback: function callback($$v) {
          _vm.proxy = $$v;
        },
        expression: "proxy"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
  })], 2) : _vm._e(), _vm.step == '2' ? _c('div', [_c('div', {
    staticClass: "scan-filter"
  }, [_c('coupon-filters', {
    staticClass: "s-mb-3 s-mt-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.scanFilter,
      callback: function callback($$v) {
        _vm.scanFilter = $$v;
      },
      expression: "scanFilter"
    }
  })], 1), _c('div', [_vm.scanFilter == 'qrcode' ? _c('div', {
    staticClass: "qrcode-panel"
  }, [_vm.showQrCodeScanner ? _c('QRCodeScanner', {
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.onScan
    }
  }) : _vm._e()], 1) : _vm.scanFilter == 'manual' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.barcode,
      expression: "barcode"
    }],
    staticClass: "search__input m-auto w-100",
    domProps: {
      "value": _vm.barcode
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value;
      }, _vm.redeemCodeFormatter]
    }
  })]) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 rounded redeem--content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_confirm_page.content'))
    }
  })]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm.getModuleConfig('redeem_confirm_page.button_text') || _vm.getModuleConfig('redeem_confirm_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_vm.step == '1' ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.proxy
    },
    on: {
      "click": _vm.changeStep
    }
  }, [_vm._v("確認商家")]) : _vm._e(), _vm.step == '2' ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.canSubmit || _vm.showLoading
    },
    on: {
      "click": _vm.redeemCoupon
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("redeem_confirm_page.button_text")))]) : _vm._e(), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('redeem_confirm_page.cancel_button_text'),
      "button-url": _vm.getModuleConfig('redeem_confirm_page.cancel_button_url'),
      "type": _vm.getModuleConfig('redeem_confirm_page.cancel_button_action')
    }
  })], 1) : _vm._e()])] : [_c('div', {
    staticClass: "coupon--header"
  }, [_c('div', {
    staticClass: "s-px-3 s-text-2xl s-font-bold text-truncate"
  }, [_vm._v(" 此優惠券不存在 ")]), _vm.errorMessage ? _c('div', [_c('p', {
    staticClass: "s-mt-2"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('redeem_confirm_page.cancel_button_text'),
      "button-url": _vm.getModuleConfig('redeem_confirm_page.cancel_button_url'),
      "type": _vm.getModuleConfig('redeem_confirm_page.cancel_button_action')
    }
  })], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }